import { cardeal } from './api';

export class LimitePorcentagemSaqueService {
  getLimitePorcentagemSaque = (matricula = '', plano = '') => {
    return cardeal.get('ObterLimitePorcentagemSaqueAVista', {
      params: {
        matricula,
        plano,
      },
    });
  };
}
